<template>
  <div class="modal fade" :id="`deleteRegionModal` + userData.id" tabindex="-1" role="dialog">
    <div class="modal-dialog modal-dialog-centered" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">確認刪除 {{ userData.email }}？</h5>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-secondary" data-dismiss="modal">取消</button>
          <button type="button" class="btn btn-danger" @click="deleteUserFromRegion(regionId, userData.id)"
            data-dismiss="modal">
            刪除
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  methods: {
    deleteUserFromRegion(region_id, user_id) {
      axios.delete(base_url + `/api/share/region?user_id=${user_id}&region_id=${region_id}`)
        .then(response => {1
          this.$emit('update-user')
        })
        .catch(error => { console.error('Error adding mac into region:', error.toJSON()); })

    },
  },
  props: ['regionId', 'userData'],
}
</script>

<style></style>
